import { render } from "./EditPhoto.vue?vue&type=template&id=29e31223"
import script from "./EditPhoto.vue?vue&type=script&lang=js"
export * from "./EditPhoto.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__